common.View.create('website::layouts.main.Footer', {

    onDOMLoad() {
        this.initAlert();
    },

    initAlert() {
        let alert = this.element.find('.alert');

        if(alert.length == 0)
            return;

        $('html, body').animate({
            scrollTop: alert.offset().top - 100,
        }, 1000);
    }
});
